<template>
  <div>
    <div class="footer">
      <div class="logo float-right">
        <b-img :src="require('../../assets/FairmatLogoWhite.png')" alt="Fairmat" class="logo-image"></b-img>
      </div>
      <div class="description" v-html="$t('footer')"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'custom-footer',
}
</script>
<style lang="scss" scoped>
.spacer {
  padding-bottom: 60px;
}

.footer {
  width: 100%;
  background-color: #23303a;
  color: #b4b4b4;
  height: 60px;
  bottom: 0;
  left: 0;
  z-index: 9;
}

.footer .description {
  padding: 20px 10px;
  text-align: left;
  height: 100%;
}

.footer .logo {
  padding: 10px 10px;
  vertical-align: middle;
  overflow: hidden;
  margin-top: 5px;
}

.logo-image {
  height: 30px;
  overflow: hidden;
  margin-top: 5px;
}
</style>
